import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { initialGroupByPeriodFilter } from "./FilterTypes/GroupByPeriodFilterType";

interface GroupByPeriodOption {
  label: string
  value: server.dto.PeriodOptions
};

const GroupByPeriodFilter = () => {
  const title = RESX.DateTime.Period;

  const options: GroupByPeriodOption[] = [
    { label: RESX.DateTime.PerYear, value: "year" },
    { label: RESX.DateTime.PerQuarter, value: "quarter" },
    { label: RESX.DateTime.PerMonth, value: "month" }
  ];

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("groupByPeriod", {
    getTitle: () => title,
    renderSelection: (value) => <>{options.find(o => o.value === value.groupBy)?.label}</>,
    hasValue: () => true,
    reset: () => initialGroupByPeriodFilter,
    areEqual: (a, b) => a.groupBy === b.groupBy
  });
  useEffect(() => {
    setInitialValue("groupByPeriod", initialGroupByPeriodFilter);
  }, []);

  const [selectedGroupByPeriod, setSelectedGroupByPeriod] = React.useState<GroupByPeriodOption>(options.find(f => f.value === initialGroupByPeriodFilter.groupBy));

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onChange = (option: GroupByPeriodOption) => {
    setSelectedGroupByPeriod(option);
    setPopupOpen(false);
    setValue("groupByPeriod", {
      groupBy: option.value
    });
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedGroupByPeriod(options.find(f => f.value === getValue("groupByPeriod").groupBy));
    setPopupOpen(true);
  };

  const onApplyFilter = (e?) => {
    e?.preventDefault();
    setValue("groupByPeriod", {
      groupBy: selectedGroupByPeriod?.value
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={onApplyFilter}>
        <SelectableList
          noSearch
          selectedItems={selectedGroupByPeriod != null ? [selectedGroupByPeriod] : []}
          items={options}
          onItemToggled={onChange}
          getId={p => p.value}
          getName={b => b.label}
        />
      </form>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default GroupByPeriodFilter;